module.exports = __webpack_public_path__ + "static/media/nynorsk-ordforstaelse.8a2e8796.mp3";